import { Select } from 'antd';
import React, { HTMLAttributes, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import '../../../node_modules/flag-icon-css/css/flag-icon.css';
import { countriesList } from './country-codes-list';
import { TAInputGroup, TASelect } from '../dashboard/styles';
import { TAInput } from '../widgets';

let countries = countriesList.sort((a, b) => {
	if (b.en > a.en) {
		return -1;
	}
	if (a.en > b.en) {
		return 1;
	}
	return 0;
});

interface IPhoneInputProps {
	value?: { short: string; code: string; phone: string };
	defaultCountryCode?: string;
	onChange?: (val: any) => void;
	placeholder?: string;
}

export const PhoneInput: React.FC<IPhoneInputProps & HTMLAttributes<HTMLDivElement>> = ({
	onChange,
	value,
	defaultCountryCode,
	placeholder,
	lang = 'en'
}) => {
	const defaultCountry = useMemo(() => {
		return countries.find(
			c => c.short === defaultCountryCode || c.short === 'EG'
			// c => c.short === defaultCountryCode || c[lang] === defaultCountryCode || c.short === 'EG'
		);
	}, []);

	const [country, setCountry] = useState(defaultCountry);
	const [phone, setPhone] = useState('');
	const phoneRef = useRef(null);

	useEffect(() => {
		if (value !== undefined) {
			if (value.short) {
				setCountry(countries.find(c => c.short === value.short));
			} else {
				setCountry(countries.find(c => c.phoneCode === value.code));
			}
			setPhone(value.phone);
		}
	}, [value]);

	const triggerChange = useCallback(
		(phone, country) => {
			const result: any = {
				phone,
				code: country && country.phoneCode,
				short: country && country.short
			};
			if (onChange) {
				onChange(result);
			}
		},
		[onChange]
	);

	const handleCountryChange = useCallback(
		value => {
			const c = countries.find(c => c.short === value);
			if (!c) {
				throw new Error(`Country not found: ${value}`);
			}
			setCountry(c);
			triggerChange(phone, c);
		},
		[setCountry, triggerChange, phone]
	);

	const handlePhoneChange = useCallback(() => {
		const currentRef = phoneRef?.current as any;
		const value = currentRef.input.value;

		setPhone(value);
		triggerChange(value, country);
	}, [setPhone, country, triggerChange]);

	return (
		<TAInputGroup compact>
			<TASelect
				// bordered={false}
				dropdownStyle={{ zIndex: 3000 }}
				value={country && country.short}
				style={{ width: '114px' }}
				dropdownMatchSelectWidth={false}
				optionLabelProp="label"
				onChange={handleCountryChange}
				showSearch={true}
				allowClear={false}
				filterOption={(input, option) => {
					return (option.children[1] + option.children[2]).indexOf(input.toLowerCase()) >= 0;
				}}
			>
				{countries.map(item => {
					const fix = {
						key: item.short,
						value: item.short,
						label: (
							<span>
								<span
									className={`flag-icon flag-icon-${item.short.toLowerCase()}`}
									style={{ marginRight: '2px' }}
								></span>
								<span>+{item.phoneCode}</span>
							</span>
						)
					};
					return (
						<Select.Option {...fix}>
							{<span className={`flag-icon flag-icon-${item.short.toLowerCase()}`}></span>} +
							{item.phoneCode}
						</Select.Option>
					);
				})}
			</TASelect>
			<TAInput
				style={{ width: 'calc(100% - 114px)' }}
				ref={phoneRef}
				onChange={handlePhoneChange}
				value={value && value.phone}
				placeholder={placeholder}
			/>
		</TAInputGroup>
	);
};
